import React from 'react';
import { useInView } from 'react-intersection-observer';
import { isMobile } from 'mobile-device-detect';
import '../../styles/about/overview.css';
import infographic from '../../assets/img/proms-infographic.jpg';

const OverviewSection = () => {
	const { ref: overviewSectionRef, inView: isVisible } = useInView({
		triggerOnce: true,
		threshold: 0.5,
	});

	return (
		<section
			id="overview"
			className={`overview ${isMobile ? '' : isVisible ? 'animate' : ''}`}
			ref={overviewSectionRef}
		>
			<img
				src={infographic}
				alt="ProMS Infographic"
				className="overview-infographic"
			/>
			<span className="overview-text-content">
				<h2>What is ProMS?</h2>
				<p>
					Proteome Medicine Sweden (ProMS) is a national innovation
					environment that connects academic research, healthcare
					implementation, and industrial development to integrate
					proteomics into precision medicine.
				</p>
			</span>
		</section>
	);
};

export default OverviewSection;
